import { Timeline } from '../Timeline/timeline';
import './roadmap.css';
export const Roadmap = () => {
  return (
    <div id='roadmap' className='text-center'>
      <div className='container'>
        <div className='section-title'>
          <h2>Roadmap</h2>
          <p>RubyRock is a multi-phase project with a focus on storing and creating future value.  Leveraging blockchain technology, RubyRock is a unique NFT combining DeFi and Artwork with a Real Asset; essentially creating a solid intrinsic value with an unlimited upside potential.</p>
          <Timeline />
          <br/>
          <h3>Much more to come Rubyfamily</h3>
        </div>
      </div>
    </div>
  )
}